export enum CheckInType {
    PICKUP = 1,
    DELIVERY = 2,
}
